export default (errorMessage) => (value) =>
  (value && !!value.length) || errorMessage
